import { QR_SERVICE_API_URL } from "./config";

interface Props {
  branchId: string;
  rating: number;
  text: string;
  feedbackRequested: boolean;
  name: string | null;
  phone: string | null;
}

interface Response {
  id: number;
  rating: number;
  text: string;
  company_branch_id: string;
  created_at: string;
  feedback_requested: boolean;
  name: string | null;
  phone: string | null;
}

export const createReview = async (props: Props): Promise<Response> => {
  const { branchId, rating, text, feedbackRequested, name, phone } = props;

  const response =
    await fetch(`${QR_SERVICE_API_URL}/api/v1/reviews/${branchId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        rating,
        text,
        feedback_requested: feedbackRequested,
        name,
        phone,
      }),
    });

  if (!response.ok) {
    throw new Error(`Статус ошибки - ${response.status}`);
  }

  return await response.json();
};
